var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFuelJeta1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-55 147 500 625",
    style: {
      enableBackground: "new -55 147 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M427.5 415.6c0-37.8-10.8-74.2-30.5-105.3 0-.5 0-1-.1-1.5l-5.1-43.2c-.5-3.8-2.4-7.4-5.5-9.8l-49.6-39c-3.8-3-8.7-3.8-13.1-2.6L273.9 175l-15.1 19.1 50.3 39.6c0 .4 0 .7.1 1.1l6.2 55.3c.4 3.9 2.4 7.4 5.5 9.8l43.1 33.9c2.8 2.2 6.1 3.2 9.4 3.1 13.1 23.8 20.1 50.7 20.1 78.7l.8 97.8c1.6 23.5-17.7 46.1-43.1 46.1-23.8 0-43.2-19.4-43.2-43.2V391.9c0-34.3-28.1-58.8-57.9-58.8h-7V175.9c0-16-13-28.9-28.9-28.9H16.9C.9 147-12 159.9-12 175.9v427.3c0 4.6-3.7 8.2-8.3 8.2h-9c-4.6 0-8.3 3.6-8.3 8.2v19.2c0 4.6 3.7 8.3 8.3 8.3h289.6c4.6 0 8.3-3.7 8.3-8.3v-19.2c0-4.6-3.7-8.2-8.3-8.2h-9c-4.6 0-8.3-3.6-8.3-8.2V365.8h4.9c19.3 0 27 15.4 27 26v124.4c0 42.1 34.2 76.3 76.3 76.3 42.3 0 78.2-35.6 76.2-79.1l.1-97.8zm-217.4-96.8c0 4.6-3.7 8.3-8.3 8.3h-170c-4.6 0-8.3-3.7-8.3-8.3V189.5c0-4.6 3.7-8.3 8.3-8.3h170.1c4.6 0 8.3 3.7 8.3 8.3v129.3h-.1z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelJeta1);
export default __webpack_public_path__ + "static/media/fuel_jeta1.d2495b2a24677ec8d739dd5290290453.svg";
export { ForwardRef as ReactComponent };